module.exports = __webpack_public_path__ + "img/Truppführer_TS.c144c912.svg";